// removed by extract-text-webpack-plugin
module.exports = {"Textblock":"skills__Textblock__3ayBn","TextBlock":"skills__TextBlock__2fNu0","SkillsSummaryContainer":"skills__SkillsSummaryContainer__UP3A6","Content":"skills__Content__mRmUK","fadeInLoad":"skills__fadeInLoad__243Ox"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/skills.css
// module id = 91
// module chunks = 0